module.exports = __webpack_public_path__ + "img/newchris-91.49e299b5.jpg";